import React from 'react';
import { LoadingImage } from './styles';
import Image from '../../image';

interface Props {
  isProjectOverView?: boolean;
}

export default function ReportTimeLineLoading({ isProjectOverView }: Props) {
  return (
    <LoadingImage isProjectOverView={isProjectOverView}>
      <Image imageKey={'loading_state'} alt='loading-state' width={26} height={26} />
    </LoadingImage>
  );
}
